// extracted by mini-css-extract-plugin
export var checkbox = "_5k-0";
export var circle = "_5k-3";
export var horizontalContainer = "_5k-7";
export var sm = "_5k-5";
export var switch0 = "_5k-2";
export var switchDisabled = "_5k-8";
export var switchEnabled = "_5k-1";
export var textSwitchContainer = "_5k-9";
export var textSwitchOption = "_5k-a";
export var textSwitchOptionSelected = "_5k-b";
export var verticalContainer = "_5k-6";
export var xs = "_5k-4";